import Link from 'next/link';
import i18n from 'src/utils/translate';
import NavBar from 'src/components/navBar';
export default function TagNavbar({
  tagName,
  resultsType
}: {
  tagName: string;
  resultsType: string;
}) {
  return <NavBar data-sentry-element="NavBar" data-sentry-component="TagNavbar" data-sentry-source-file="tagNavbar.tsx">
      <Link as={`/tag/${tagName}`} className={resultsType === 'posts' ? 'active' : ''} href={`/tag?slug=${tagName}&type=posts`} data-sentry-element="Link" data-sentry-source-file="tagNavbar.tsx">
        {i18n.t('Posts')}
      </Link>
      <Link as={`/tag/${tagName}?type=communities`} className={resultsType === 'communities' ? 'active' : ''} href={`/tag?slug=${tagName}&type=communities`} data-sentry-element="Link" data-sentry-source-file="tagNavbar.tsx">
        {i18n.t('Communities')}
      </Link>
    </NavBar>;
}